import { styled } from "@mui/material/styles";
const BookingStatusWrap = styled("div")(({ theme }) => ({
  marginTop: "40px",
  marginLeft: "auto",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  [theme.breakpoints.up("md")]: {
    width: "100%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "80%",
  },
}));
const BookingStatusBar = styled("ul")(({ theme }) => ({
  listStyle: "none",
  position: "relative",
  paddingLeft: "35px",

  "&::before": {
    display: "inline-block",
    content: '""',
    position: "absolute",
    top: "19px",
    left: "15px",
    width: "10px",
    height: "100%",
    borderLeft: "4px solid rgba(11, 11, 11, 0.3)",
  },
}));

const LiMain = styled("li")(({ theme }) => ({
  position: "relative",
  "&::before": {
    display: "inline-block",
    content: '""',
    position: "absolute",
    left: "-20px",
    height: "100%",
    width: "10px",
    top: 0,
  },
  "&.activeli::before": {
    borderLeft: "4px solid #0B0B0B",
    top: "20px",
  },
  "&.activeli::after": {
    background: "#0B0B0B",
  },
  // "&.activeli + li::after": {
  //   background: "#0B0B0B",
  // },
  "&::after": {
    content: "''",
    position: "absolute",
    top: "10px",
    left: "-25px",
    height: "15px",
    width: "15px",
    background: "rgba(11, 11, 11, .5)",
    borderRadius: "50px",
  },
  "&:last-child::before": {
    background: "#fff",
    top: "19px",
  },
  marginBottom: "10px",
  "& .itemMain": {
    display: "flex",
    gap: "10px",
  },
  "& .itemimg img": {
    width: "100%",
    height: "auto",
  },

  "&.requestSection": {
    "&:before": {
      borderLeft: "4px solid #FF0099",
      top: "20px",
    },
    "&:after": {
      background: "#FF0099",
    },
    "& h6": {
      color: "#FF0099",
    },
  },
  "&.cancelledSection": {
    "&:before": {
      borderLeft: "4px solid red",
      top: "20px",
    },
    "&:after": {
      background: "red",
    },
    "& h6": {
      color: "red",
    },
  },
  "&.DriverSection": {
    "&:before": {
      borderLeft: "4px solid #005F4E",
      top: "25px",
    },
    "&:after": {
      background: "#005F4E",
    },
    "& h6": {
      color: "#005F4E",
    },
  },
  "&.DriverArrived": {
    "&:before": {
      borderLeft: "4px solid #FF9900",
      top: "25px",
    },
    "&:after": {
      background: "#FF9900",
    },
    "& h6": {
      color: "#FF9900",
    },
  },
  "&.PickedOrder": {
    "&:before": {
      borderLeft: "4px solid #0075FF",
      top: "25px",
    },
    "&:after": {
      background: "#0075FF",
    },
    "& h6": {
      color: "#0075FF",
    },
  },
  "&.DriverDeparted": {
    "&:before": {
      borderLeft: "4px solid #C3006A",
      top: "25px",
    },
    "&:after": {
      background: "#C3006A",
    },
    "& h6": {
      color: "#C3006A",
    },
  },
  "&.Dropoff": {
    "&:before": {
      borderLeft: "4px solid #9E00FF",
      top: "25px",
    },
    "&:after": {
      background: "#9E00FF",
    },
    "& h6": {
      color: "#9E00FF",
    },
  },
  "&.Dropoff": {
    "&:before": {
      borderLeft: "4px solid #9E00FF",
      top: "25px",
    },
    "&:after": {
      background: "#9E00FF",
    },
    "& h6": {
      color: "#9E00FF",
    },
  },
  "&.OrderDelivered": {
    "&:after": {
      background: "#3DC000",
    },
    "& h6": {
      color: "#3DC000",
    },
  },
}));
const ItemText = styled("div")(({ theme }) => ({
  "& h6": {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "19px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    paddingBottom: "4px",
  },
  "& p": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19px",
    color: "rgba(11, 11, 11, 0.5)",
    fontFamily: theme.typography.fontFamily,
  },
  "& span": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "12px",
    color: "rgba(11, 11, 11, 0.8)",
    fontFamily: theme.typography.fontFamily,
  },
}));

export { BookingStatusWrap, BookingStatusBar, LiMain, ItemText };
